import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/Card";
import { Badge } from "../../../components/ui/Badge";
import { Checkbox } from "../../../components/ui/Checkbox";
import { Label } from "../../../components/ui/Label";

const FilterPanel = ({
  categories = [],
  tags = [],
  onCategorySelect,
  onTagSelect,
  selectedCategory,
  selectedTag,
}) => {
  return (
    <div className="space-y-6">
      {/* Categories Filter */}
      <Card className="shadow-elegant">
        <CardHeader>
          <CardTitle className="text-lg">Categories</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {categories.length === 0 ? (
            <p className="text-sm text-muted-foreground">No categories available yet.</p>
          ) : (
            categories.map((category) => {
              const normalizedCategory = category.name.toLowerCase().replace(/\s+/g, '-');
              const isSelected =
                selectedCategory === normalizedCategory ||
                selectedCategory === category.name.toLowerCase();
              return (
                <div
                  key={category.name}
                  className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded-md transition-colors"
                  onClick={() => onCategorySelect && onCategorySelect(category.name)}
                >
                  <div className="flex items-center gap-2 flex-1">
                    <Checkbox
                      id={category.name}
                      checked={isSelected}
                      onCheckedChange={() => onCategorySelect && onCategorySelect(category.name)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <Label
                      htmlFor={category.name}
                      className="text-sm cursor-pointer hover:text-primary transition-smooth flex-1"
                    >
                      {category.name}
                    </Label>
                  </div>
                  <Badge variant="secondary" className="text-xs">
                    {category.count}
                  </Badge>
                </div>
              );
            })
          )}
        </CardContent>
      </Card>

      {/* Tags Filter */}
      <Card className="shadow-elegant">
        <CardHeader>
          <CardTitle className="text-lg">Popular Tags</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {tags.length === 0 ? (
            <p className="text-sm text-muted-foreground">No tags available yet.</p>
          ) : (
            tags.map((tag) => {
              const isSelected =
                selectedTag === tag.name ||
                selectedTag?.toLowerCase() === tag.name.toLowerCase();
              return (
                <div
                  key={tag.name}
                  className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded-md transition-colors"
                  onClick={() => onTagSelect && onTagSelect(tag.name)}
                >
                  <div className="flex items-center gap-2 flex-1">
                    <Checkbox
                      id={tag.name}
                      checked={isSelected}
                      onCheckedChange={() => onTagSelect && onTagSelect(tag.name)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <Label
                      htmlFor={tag.name}
                      className="text-sm cursor-pointer hover:text-primary transition-smooth flex-1"
                    >
                      {tag.name}
                    </Label>
                  </div>
                  <Badge variant="secondary" className="text-xs">
                    {tag.count}
                  </Badge>
                </div>
              );
            })
          )}
        </CardContent>
      </Card>

      {/* Quick Links */}
      <Card className="shadow-elegant gradient-accent text-primary-foreground">
        <CardHeader>
          <CardTitle className="text-lg">Need Help?</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm mb-4 opacity-90">
            Can't find what you're looking for? Our support team is here to help.
          </p>
          <button className="w-full py-2 px-4 bg-card text-foreground rounded-lg font-medium hover:bg-card/90 transition-smooth">
            Contact Support
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default FilterPanel;
